const HTML_EDIT_MODAL_ID = `HTML.edit`;
const HTML_BUTTONS = {
  alignment: "HTML.alignment",
  edit: "HTML.edit",
  width: "HTML.width",
  height: "HTML.height"
};
export {
  HTML_BUTTONS,
  HTML_EDIT_MODAL_ID
};
//# sourceMappingURL=consts.js.map
